import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
//
import Loader from 'components/common/Loader';
import { CloseIcon } from 'components/common/icons';
import { PAYMENT_TRANSACTIONS_COLUMN_DEFS } from 'utils/tables/columns/transactionsHistory';

import { StyledTransactionsGrid } from '../transactions.styles';
import { useGetPublisherTransactionDetailsQuery } from '../../../store/api/transaction.api';

const PaymentDetails = (props) => {
  const { data: paymentTransactions = [], isFetching: isPending } =
    useGetPublisherTransactionDetailsQuery(props?.payment?.paymentNumber, {
      skip: !props?.payment?.paymentNumber,
    });

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.handleClose}
      PaperProps={{
        style: {
          minWidth: '1100px',
        },
      }}
      scroll='paper'
    >
      <Loader isPending={isPending} />
      <DialogTitle id='alert-dialog-title'>
        Payment: #{props.payment.paymentNumber}
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers>
        <DialogContentText id='alert-dialog-description'>
          <StyledTransactionsGrid
            rows={paymentTransactions}
            columns={PAYMENT_TRANSACTIONS_COLUMN_DEFS}
            sx={{
              minHeight: '200px',
            }}
            checkboxSelection={false}
            hideFooter
            hideFooterPagination
            disableRowSelectionOnClick
          />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDetails;
